import styled from '@emotion/styled';

const Content = styled.div`
  text-align: center;
  min-height: inherit;
  padding: 1.5rem;
`;

export default Content;
